import { getJti } from '@util'

/**
 * 全局产品权限 socket
 * http://jira.hunliji.com/browse/DEV-23468
 */
class Socket {
  initSocket = () => {
    // eslint-disable-next-line
    const ws = new WebSocket(`${__SOCKET__}/api/merchant/ws?jti=${getJti()}`)
    ws.onopen = () => {}
    ws.onmessage = evt => {
      const data = JSON.parse(evt.data)
      const { service, subject, payload } = data

      if (service == 'ws') {
        if (subject == 'ping') {
          const msg = {
            service: 'ws',
            subject: 'pong',
            payload
          }
          ws.send(JSON.stringify(msg))
        }
      } else if (service == 'mn') {
        // TODO
        console.log(payload)
      }
    }
    ws.onclose = () => {
      setTimeout(() => this.initSocket(), 5 * 1000)
    }
  }
}

export default Socket
